var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.ableToVote)?_c('Duel_Bar_VotingResult',{attrs:{"duel":_vm.duel}}):_c('b-collapse',{staticClass:"duel-header-voting-section",attrs:{"visible":!this.isClosed}},[_c('Duel_Voting_VoteButtons',{attrs:{"duel":_vm.duel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }